import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const MAGIC_LOGIN_PATHNAME = '/magic-login';

export const MagicLoginLoadable = loadable(async () => import('./magic-login.view'), {
  fallback: <FullPageLoading />,
});
